<template>
    <section style="margin: 18px;">
        <v-layout>
            <v-layout xs4 style="margin: 0px 24px;padding-top: 6px;" row>
                <v-flex>
                    <v-menu v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="From_Date"
                                            label="Pick From Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="From_Date" @input="menu1 = false"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex>
                     <v-menu v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="To_Date"
                                        label="Pick To date"
                                        prepend-icon="event"
                                        clearable
                                        readonly
                                        v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="To_Date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-btn icon style="margin: 0px 14px;margin-top: 13px;">
                    <v-icon @click="SearchNow">search</v-icon>
                </v-btn>
            </v-layout>
        </v-layout>
        <v-data-table :headers="headers" 
                      :items="Trainers" 
                      hide-actions
                      style="margin-bottom: 10px;"
                        class="elevation-1" 
                        disable-initial-sort>
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Email }}</td>
                    <td class="text-xs-center">{{ props.item.Name }}</td>
                    <td class="text-xs-center">{{ props.item.Phone_Number }}</td>
                    <td class="text-xs-center">{{ props.item.Skills }}</td>
                    <td class="text-xs-center">{{ new Date(props.item.Created_On).toLocaleDateString() }}</td>
                    <td class="text-xs-center">{{ props.item.Approved ? "Approved" : "Not Approved" }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" v-if="!props.item.Approved" icon class="btnAction" @click="ApproveTrainer(props.item,`Approve`)">
                            <v-icon>thumb_up</v-icon>
                        </v-btn>
                        <v-btn color="error" v-else icon class="btnAction" @click="ApproveTrainer(props.item,`Decline`)">
                            <v-icon>thumb_down</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
    </section>
</template>
<script>
export default {
    data(){
        return {
            Trainers   : [],
            headers : [ { text: 'Email',value: 'Email' },
                        { text: 'Name' ,value: 'Name'},
                        { text: 'Phone Number' ,value: 'Phone_Number'},
                        { text: 'Skills' ,value: 'Skills'},
                        { text: 'Created On',  value: 'Created_On'},
                        { text: 'Approved' ,value: 'Approved'},
                        { text: 'Actions' } ],
            pages       : 1,
            records     : 0,
            From_Date                   : null,
            To_Date                     : null,
            menu1                       : false,
            menu2                       : false,
        }
    },
    methods:{
        GetNextSetOfData(data){


            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/gettrainerprofiles`,data)
                .then(response => {
                    
                    this.Trainers = response['data']['response']
                    this.records = response['data']['Records']
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Error While Fetching Data",Color: "red",Close: false});
                });
        },
        SearchNow(){
            this.GetNextSetOfData({ 
                    'limit' : 10, 
                    'page' : this.pages ,
                    'From_Date' : this.From_Date ? new Date(this.From_Date).setHours(0,0,0,0) : "" ,
                    'To_Date'   : this.To_Date ? new Date(this.To_Date).setHours(23,59,59,59) : "" })
        },
        ApproveTrainer(Trainer,Status){

            let data = { 'Trainer_Id'   : Trainer['_id'] , 'limit' : 10, 'page' : this.pages}
            data['Update'] = {
                'Approved'     : Status == 'Approve' ? true : false
            }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/register/updatetrainerprofile`,data)
                    .then(response => {
                        
                        this.Trainers = response['data']['response']
                        this.records = response['data']['Records']
                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Successfully Approved Trainer",Color: "green",Close: false});
                    })
                    .catch(err => {

                        this.$eventHub.$emit("SNACK_BAR", { Show: true,Text: "Failed To Approve Trainer",Color: "red",Close: false});
                    });
        }
    },
    mounted(){

        this.GetNextSetOfData({ 'limit' : 10, 'page' : this.pages })
    }
}
</script>
<style>
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>